import { render, staticRenderFns } from "./select-audit-logs-event-types.vue?vue&type=template&id=4fa06dbc&scoped=true&"
import script from "./select-audit-logs-event-types.vue?vue&type=script&lang=js&"
export * from "./select-audit-logs-event-types.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa06dbc",
  null
  
)

export default component.exports